<script>
  import { fetchAlbum, CONSTS } from './utils'
  import { createFiltersTree, validateFilter } from './filter'

  import Spinner from './Spinner.svelte'
  import Widget from './Widget.svelte'
  // import WidgetV2 from './WidgetV2.svelte'
  import './styles.scss'

  export let albumId
  export let config
  export let widget_type = 'v1'

  if (!widget_type || !(widget_type === 'v1' || widget_type === 'v2')) {
    widget_type = 'v1'
  }

  let onEvent = config.onEvent || (() => {})

  if (!config) throw new Error('Please provide the config')

  let albums = []
  let filter_tree = {}
  let filter_tree_by_keys = {}

  let FILTER_LABELS_LIST = config.album.filterKeys || []

  let albumPromise = fetchAlbum(config.shopHandle, albumId, config).then(json => {
    json.images.reverse()
    let parsedAlbums = json.images.map(albumItem => {
      if (typeof albumItem.title !== 'string') {
        albumItem.title = albumItem.title.en || 'No title'
      }

      let filter = validateFilter(config.album.createFilter?.(albumItem, json.settings?.filter))

      albumItem[CONSTS.FILTER_KEY] = filter
      return albumItem
    })

    onEvent(CONSTS.EVENT.ALBUM_FETCHED, {
      albumId,
      response: json,
    })

    albums = parsedAlbums

    // let rawList = parsedAlbums
    //   .map(x => x[CONSTS.FILTER_KEY])
    //   .reduce(
    //     (acc, x) => {
    //       // remove duplicates
    //       if (!x) return acc

    //       const key = Object.values(x).join(',')
    //       if (!acc.cache.has(key)) {
    //         acc.cache.add(key)
    //         acc.list.push(x)
    //       }

    //       return acc
    //     },
    //     { list: [], cache: new Set() },
    //   )
    // rawList.cache = null
    // window.rawList = rawList.list

    filter_tree = createFiltersTree({
      data: albums,
      path: [CONSTS.FILTER_KEY],
      keys: FILTER_LABELS_LIST,
    })

    filter_tree_by_keys = FILTER_LABELS_LIST.reduce((acc, k, i) => {
      const keys = FILTER_LABELS_LIST.slice(i)
      const tree = createFiltersTree({
        data: albums,
        path: [CONSTS.FILTER_KEY],
        keys,
      })
      acc[k] = tree
      return acc
    }, {})

    // window.filter_tree_by_keys = filter_tree_by_keys
    // window.filter_tree = filter_tree

    onEvent(CONSTS.EVENT.WIDGET_READY, { albumId, response: json, filter_tree, filter_tree_by_keys })

    return json
  })

  $: {
    albumPromise
    onEvent(CONSTS.EVENT.ALBUM_LOADING, { albumId })
  }
  let albumRoot
</script>

<div class="XOC_Album_Root" bind:this={albumRoot}>
  {#if albumRoot}
    {#await albumPromise}
      <div class="XOC_Centered-spinner">
        <Spinner />
      </div>
    {:then json}
      {#key albumId}
        <Widget
          {config}
          {albumId}
          {albums}
          {albumRoot}
          {filter_tree}
          {filter_tree_by_keys}
          {widget_type}
        />
      {/key}
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  {/if}
</div>
